import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EmojiSwitchComponent } from './emoji-switch.component';

@NgModule({
    declarations: [
        EmojiSwitchComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        EmojiSwitchComponent
    ]
})
export class NcEmojiSwitchModule { }